<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :title="board_name"
      desc="등록한 노트들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push(`post/create?group_id=${group_id}&board_id=${board_id}`)"
              class="button is-primary">노트 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1000"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'GroupBoardPostList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    components: {

    },
    data () {
      return {
        group_id:0,
        board_id:0,
        board_name: ''
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.board_id = this.$route.query.board_id;
        this.group_id = this.$route.query.group_id;
        this.initializing('group_post', `group/${this.group_id}/board/${this.board_id}/post`);
        this.getBoardDetail();
      },
      getDataFromServer() {
        this.getData();
      },
      getBoardDetail() {
        this.$axios.get(this.getUrl(`group/${this.group_id}/board/${this.board_id}`)).then(res=>{
          this.board_name = res.data.name;
        })
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`group/board/post/create?
          group_id=${this.group_id}&board_id=${this.board_id}&post_id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `group/${item.group}/board/${this.board_id}/post/${item.id}`,
            title: '팀노트을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'


</style>
